import React from 'react';

interface Props {
    children: React.ReactNode
    className?: string
}

const MainContainer = ({ children, className = "" } : Props) => {  
    return (
        <main className="m-5">
            <div className={`px-5 ${className} py-5`}>
                {children}  
            </div>
            <hr></hr>
        </main>
    )
}

export default MainContainer;